 // https://www.cssfontstack.com/


const FONT_STACK_MAP = {
    // Sans-serif font stack
    'Arial': 'Arial,Helvetica Neue,Helvetica,sans-serif',
    'Arial-Black': 'Arial Black,Arial Bold,Gadget,sans-serif',
    'ArialMT': 'Arial,Helvetica Neue,Helvetica,sans-serif',
    'ArialNarrow': 'Arial Narrow,Arial,sans-serif',
    'ArialRoundedMTBold': 'Arial Rounded MT Bold,Helvetica Rounded,Arial,sans-serif',

    'AvantGarde': 'Avant Garde,Avantgarde,Century Gothic,CenturyGothic,AppleGothic,sans-serif',
    'Calibri': 'Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif',
    'Candara': 'Candara,Calibri,Segoe,Segoe UI,Optima,Arial,sans-serif',
    'CenturyGothic': 'Century Gothic,CenturyGothic,AppleGothic,sans-serif',

    'FranklinGothic-Medium': 'Franklin Gothic Medium,Franklin Gothic,ITC Franklin Gothic,Arial,sans-serif',
    'Futura': 'Futura,Trebuchet MS,Arial,sans-serif',
    'Geneva': 'Geneva,Tahoma,Verdana,sans-serifcxToJs',
    'GillSans': 'Gill Sans,Gill Sans MT,Calibri,sans-serif',

    'HelveticaNeue': 'Helvetica Neue,Helvetica,Arial,sans-serif',
    'Impact': 'Impact,Haettenschweiler,Franklin Gothic Bold,Charcoal,Helvetica Inserat,Bitstream Vera Sans Bold,Arial Black,sans-serif',
    'LucidaGrande': 'Lucida Grande,Lucida Sans Unicode,Lucida Sans,Geneva,Verdana,sans-serif',
    'Optima': 'Optima,Segoe,Segoe UI,Candara,Calibri,Arial,sans-serif',

    'Segoe UI': 'Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue,Arial,sans-serif',
    'SegoeUI': 'Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue,Arial,sans-serif',
    'Tahoma': 'Tahoma,Verdana,Segoe,sans-serif',
    'TrebuchetMS': 'Trebuchet MS,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Tahoma,sans-serif',
    'Verdana': 'Verdana,Geneva,sans-serif',

    // Serif font stack
    'BigCaslon': 'Big Caslon,Book Antiqua,Palatino Linotype,Georgia,serif',
    'BodoniMT': 'Bodoni MT,Didot,Didot LT STD,Hoefler Text,Garamond,Times New Roman,serif',
    'BookAntiqua': 'Book Antiqua,Palatino,Palatino Linotype,Palatino LT STD,Georgia,serif',
    'CalistoMT': 'Calisto MT,Bookman Old Style,Bookman,Goudy Old Style,Garamond,Hoefler Text,Bitstream Charter,Georgia,serif',

    'Cambria': 'Cambria,Georgia,serif',
    'Didot': 'Didot,Didot LT STD,Hoefler Text,Garamond,Times New Roman,serif',
    'Garamond': 'Garamond,Baskerville,Baskerville Old Face,Hoefler Text,Times New Roman,serif',
    'Georgia': 'Georgia,Times,Times New Roman,serif',

    'GoudyOldStyle': 'Goudy Old Style,Garamond,Big Caslon,Times New Roman,serif',
    'HoeflerText': 'Hoefler Text,Baskerville Old Face,Garamond,Times New Roman,serif',
    'LucidaBright': 'Lucida Bright,Georgia,serif',
    'Palatino': 'Palatino,Palatino Linotype,Palatino LT STD,Book Antiqua,Georgia,serif',

    'Perpetua': 'Perpetua,Baskerville,Big Caslon,Palatino Linotype,Palatino,URW Palladio L,Nimbus Roman No9 L,serif',
    'Rockwell': 'Rockwell,Courier Bold,Courier,Georgia,Times,Times New Roman,serif',
    'Rockwell-ExtraBold': 'Rockwell Extra Bold,Rockwell Bold,monospace,serif',
    'Baskerville': 'Baskerville,Baskerville Old Face,Hoefler Text,Garamond,Times New Roman,serif',

    'TimesNewRoman': 'TimesNewRoman,Times New Roman,Times,Baskerville,Georgia,serif',

    // Monospaced font stack
    'Consolas': 'Consolas,monaco,monospace',
    'CourierNew': 'Courier New,Courier,Lucida Sans Typewriter,Lucida Typewriter,monospace',
    'LucidaConsole': 'Lucida Console,Lucida Sans Typewriter,monaco,Bitstream Vera Sans Mono,monospace',
    'LucidaSans-Typewriter': 'Lucida Sans Typewriter,Lucida Console,monaco,Bitstream Vera Sans Mono,monospace',
    'Monaco': 'monaco,Consolas,Lucida Console,monospace',
    'AndaleMono': 'Andale Mono,AndaleMono,monospace',

    // Fantasy font stack
    'Copperplate': 'Copperplate,Copperplate Gothic Light,fantasy',
    'Papyrus': 'Papyrus,fantasy',

    // Script font stack
    'BrushScriptMT': 'Brush Script MT,cursive'
};

module.exports = { 
    FONT_STACK_MAP: FONT_STACK_MAP
};